import { render } from "./Index.vue?vue&type=template&id=723fc2e0"
const script = {}

import exportComponent from "/codebuild/output/src996785304/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__